<template>
    <el-dialog
        :visible.sync="visibleSync"
        append-to-body
        :close-on-click-modal="false"
        :show-close="false"
        class="note-dialog"
        top="5vh"
    >
        <div class="notice-title">更新内容</div>
        <div class="notice-content" v-html="notice.contents"></div>
        <div slot="footer">
            <div class="btn-line">
                <el-button
                    type="primary"
                    plain
                    class="cancelBtn"
                    @click="handleKnow"
                >
                    {{ text }}
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { getNoticeById } from "@/api/sysMsg";
import { apiCallback } from "@/utils";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        text:{
            type: String,
            default: '我知道了'
        }
    },
    data() {
        return {
            visibleSync: false,
            curId: null,
            notice: {},
        };
    },
    watch: {
        visible(val) {
            this.visibleSync = val;
        },
    },
    methods: {
        loadNoticeDetail(id){
            this.curId = id;
            getNoticeById({
                id
            }).then((res) => {
                const data = apiCallback(res);
                this.notice = data;
            });
        },
        open(id) {
            this.visibleSync = true;
            this.loadNoticeDetail(id);
        },
        handleKnow() {
            this.visibleSync = false;
            this.$emit('know', this.curId);
        }
    }
};
</script>
<style lang="stylus">
.note-dialog{
    padding: 0 !important;
    .el-dialog{
        // background-image: url("./imgs/notes-1/bgc.png");
        // background-size: 100% 100%;
        border-radius: 10px;
    }
    .el-dialog__header{
        display: none;
    }
    .el-dialog__body{
        padding: 0;
        box-sizing: border-box;
        color:#003333;
    }

    .notice-title{
        font-size: 24px;
        padding: 20px 0;
        font-weight: bold;
        text-align: center;
    }

    .notice-content{
        max-height: 70vh;
        overflow: auto;
        padding: 0 30px;
        padding-bottom:10px;
        img{
            max-width: 100%;
            height: auto;
        }
    }

    .replenish-info{
            display: flex;
            justify-content: flex-end;
            .content{
                display: flex;
                width: fit-content;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
            }
        }
        .btn-line{
            display:flex;
            justify-content:flex-end;
            margin-top: 20px;
            width : 100%;
            padding-bottom: 20px;
        }
        .cancelBtn {
            color: white;
            background: linear-gradient(to right,#2980b9,#6dd5fa)  !important;
            border-radius: 15px;
            width:120px;
        }
}
</style>
